var FeedDataType = {
    TdsV1: { id: 1, name: "TdsV1", disabled: false, visible: true, selected: true, labelId: 'feed.datatype.tdsv1' },
    TdsV2: { id: 2, name: "TdsV2", disabled: true, visible: false, labelId: 'feed.datatype.tdsv2' },
    VolvoDynafleetTrackingDataV2: { id: 4, name: "VolvoDynafleetTrackingDataV2", disabled: true, labelId: 'feed.datatype.volvodynafleet' },
    PvhProemionV1: { id: 5, name: "PvhProemionV1", disabled: true, labelId: 'feed.datatype.pvhproemionv1' },
    PvhSigfoxV1: { id: 6, name: "PvhSigfoxV1", disabled: true, labelId: 'feed.datatype.pvhsigfoxv1' },
    PvhIxonV1: { id: 7, name: "PvhIxonV1", disabled: true, labelId: 'feed.datatype.pvhixonv1' },
    PvhSigfoxEventsV1: { id: 8, name: "PvhSigfoxEventsV1", disabled: true, labelId: 'feed.datatype.pvhsigfoxeventsv1' },
    Pvh: { id: 8, name: "Pvh", disabled: true, labelId: 'feed.datatype.pvh' },
    PvhLinkManualV1: { id: -1, name: "PvhLinkManualV1", disabled: true, labelId: 'feed.datatype.pvhmanual' },
    TdsV2VolvoCareTrack: { id: 11, name: "TdsV2VolvoCareTrack", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2.volvocaretrack' },
    TdsV2Cat: { id: 12, name: "TdsV2Cat", disabled: false, visible: true, labelId: 'feed.datatype.tdsv2.cat' },
};
export function getFeedDataNameByValue(value) {
    var keys = Object.keys(FeedDataType);
    var found = keys.find(function (key) {
        return FeedDataType[key] === value;
    });
    return found != null ? found : value;
}
export default FeedDataType;
